export const PHONE_REGEXP =
  /^\+?[0-9]{1,4} ?(\([0-9]{2,3}\) ?)?[0-9]{3,4} ?-? ?[0-9]{3,4}$/;
